import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import posthog from 'posthog-js';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();

	Sentry.init({
		//dsn: 'https://5255418266c8765aa0f60f13a377393a@o4508800261619712.ingest.us.sentry.io/4509993633054720',
		dsn: 'https://Ea58p5NAqpMhV8FxcsJkrZpp@eu-nbg-2.betterstackdata.com/1584116',
		// Setting this option to true will send default PII data to Sentry.
		// For example, automatic IP address collection on events
		sendDefaultPii: true,
		integrations: [
			Sentry.browserTracingIntegration()
		],
		// Tracing
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: [
			'localhost',
			/^https:\/\/([a-zA-Z0-9-]+\.)*paintprojex\.com/
		],
		// Enable sending logs to Sentry
		enableLogs: true,
		environment: environment.env
	});
}

if (environment.posthog) {
	posthog.init(
		'phc_A3vBHz8ZMD438GbvIHbQ3MC2mU82b011SGcZXZGiCJk',
		{
			api_host: 'https://us.i.posthog.com',
			person_profiles: 'identified_only',
		}
	);
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => console.log(err));
